module.exports = __webpack_public_path__ + "img/isle_project_2.ac3870dd.gif";